import {
    OUTLOOK_DESKTOP,
    MAC_OUTLOOK,
    IOS_OUTLOOK,
    ANDROID_OUTLOOK,
    NATIVE,
    TEAMS,
    O365_SHELL,
    WIDGET,
    getOpxHostApp,
    WIN32_OUTLOOK_HUB,
    TEAMS_HUB,
    HUB,
    getHostHub,
    ANDROID_TEAMS,
    IOS_TEAMS,
    ANDROID_OUTLOOK_LITE,
    OUTLOOK_EXTENSION,
} from 'owa-config';
import { getFlagDefaults } from './flagsDefaults';
import { isNative } from './utils/isNative';
import { isHostedInTeams } from 'owa-opx';

export const isHostAppFeatureEnabled = (flagName: string): boolean => {
    const featureFlag = getFlagDefaults(flagName);

    if (featureFlag) {
        if (isNative() && NATIVE in featureFlag) {
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2322 (32,13): Type 'boolean | undefined' is not assignable to type 'boolean'.
            // @ts-expect-error
            return featureFlag[NATIVE];
        }
        if (isHostedInTeams() && TEAMS in featureFlag) {
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2322 (38,13): Type 'boolean | undefined' is not assignable to type 'boolean'.
            // @ts-expect-error
            return featureFlag[TEAMS];
        }

        let hostHub = getHostHub();
        if (hostHub && hostHub in featureFlag) {
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS7053 (46,20): Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'HOST_APP_FLAG'.
            // @ts-expect-error
            return featureFlag[hostHub];
        }
        if (
            hostHub &&
            (hostHub === TEAMS_HUB || hostHub === WIN32_OUTLOOK_HUB) &&
            HUB in featureFlag
        ) {
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2322 (56,13): Type 'boolean | undefined' is not assignable to type 'boolean'.
            // @ts-expect-error
            return featureFlag[HUB];
        }

        const hostApp = getOpxHostApp();
        if (hostApp && hostApp in featureFlag) {
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS7053 (64,20): Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'HOST_APP_FLAG'.
            // @ts-expect-error
            return featureFlag[hostApp];
        }
        if (
            hostApp &&
            (hostApp === OUTLOOK_DESKTOP ||
                hostApp === MAC_OUTLOOK ||
                hostApp === IOS_OUTLOOK ||
                hostApp === ANDROID_OUTLOOK ||
                hostApp === TEAMS ||
                hostApp === ANDROID_TEAMS ||
                hostApp === IOS_TEAMS ||
                hostApp === ANDROID_OUTLOOK_LITE ||
                hostApp === OUTLOOK_EXTENSION ||
                hostApp === O365_SHELL ||
                hostApp === WIDGET) &&
            'opx' in featureFlag
        ) {
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2322 (84,13): Type 'boolean | undefined' is not assignable to type 'boolean'.
            // @ts-expect-error
            return featureFlag['opx'];
        }

        return featureFlag['default'];
    }

    return false;
};
